import React from 'react'

import useResearcher from './useResearcher'
import useFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { menuTab } from '../../../../../../constants/constants'
import CloseProjectResearcher from '../../../page/closeProjectResearcher/closeProjectResearcher'
import ResultOfConsider from '../../../page/resultOfConsider/closeProject/resultOfConsider'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
type ResearcherViewType = ResearcherType & ReturnType<typeof useResearcher>
const ResearcherView: React.FC<ResearcherViewType> = (props) => {
    const folderAndTabStore = useFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const renderPage = () => {
        switch (folderAndTabStore?.tabSelected?.id) {
            case menuTab.tab21.id:
            case menuTab.tab25.id:
                return <CloseProjectResearcher />
            case menuTab.tab23.id:
                return <ResultOfConsider projectData={manageProjectStore?.projectData ?? undefined} />
            default:
                return <></>
        }
    }
    return renderPage()
}

export type ResearcherType = {
    projectMode: 'CREATE' | 'EDIT'
    callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
}
const Researcher: React.FC<ResearcherType> = (props) => {
    const researcher = useResearcher(props)
    return <ResearcherView {...props} {...researcher} />
}
export default Researcher
